<template></template>
<script>
import { mapGetters, mapActions } from 'vuex';
import axios from '../../shared/axios';
export default {
  methods: {
    ...mapActions('auth', ['emulate'])
  },
  created() {
    axios.get('client/reset/emulation').then(r => {
      this.emulate(r.data);
      location.href = '/dashboard';
    });
  }
};
</script>
